var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogorut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1500,
    height: 296,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C3.32156597 2.40729228 5.6568787 2.74438677 8 3 C8 3.66 8 4.32 8 5 C9.27875 5.268125 10.5575 5.53625 11.875 5.8125 C15.49675855 6.57190099 15.80051868 6.70077803 18 10 C18.99 10.33 19.98 10.66 21 11 C21.68645609 12.32325366 22.34935371 13.65877607 23 15 C24.40181209 16.59459568 25.8436344 18.15444868 27.3125 19.6875 C31.4018642 24.12643888 34.39130443 28.5728645 37 34 C37.66 34 38.32 34 39 34 C39.12375 35.2375 39.2475 36.475 39.375 37.75 C39.75746305 40.8762197 40.30549523 43.28879237 42 46 C42.33 46 42.66 46 43 46 C44.62162429 53.50001236 44.62162429 61.49998764 43 69 C42.34 69 41.68 69 41 69 C40.67 72.3 40.34 75.6 40 79 C39.34 79 38.68 79 38 79 C37.50693359 80.01707031 37.50693359 80.01707031 37.00390625 81.0546875 C33.70642347 87.50667277 29.99410431 92.60472565 24.953125 97.80859375 C22.93957887 99.86717013 22.93957887 99.86717013 21.921875 102.22265625 C21 104 21 104 18 105 C17.401875 105.61875 16.80375 106.2375 16.1875 106.875 C11.71900584 111.2158229 7.08950196 112.3910498 1 113 C1 113.66 1 114.32 1 115 C-3.95 115.495 -3.95 115.495 -9 116 C-8.34 117.32 -7.68 118.64 -7 120 C-6.01 120.33 -5.02 120.66 -4 121 C-3.4609375 122.83203125 -3.4609375 122.83203125 -3 125 C-1.94112629 126.91159448 -1.94112629 126.91159448 -0.625 128.6875 C-0.20476562 129.28949219 0.21546875 129.89148438 0.6484375 130.51171875 C2.03645384 132.28421065 2.03645384 132.28421065 5 133 C5.10997314 133.74749512 5.21994629 134.49499023 5.33325195 135.26513672 C6.03168642 138.12997118 6.83162711 139.4931214 8.66796875 141.7578125 C9.50255615 142.80509521 9.50255615 142.80509521 10.35400391 143.87353516 C10.95905762 144.61651855 11.56411133 145.35950195 12.1875 146.125 C13.47218498 147.73788676 14.75467159 149.35252656 16.03515625 150.96875 C16.69402832 151.79890625 17.35290039 152.6290625 18.03173828 153.484375 C21.14886367 157.46835664 24.14063267 161.54110689 27.125 165.625 C30.56779689 170.33560818 34.01532968 175.03892876 37.546875 179.68359375 C38.38774658 180.79130127 38.38774658 180.79130127 39.24560547 181.92138672 C40.30839507 183.31795022 41.37495791 184.71165268 42.44580078 186.10205078 C46 190.77952835 46 190.77952835 46 193 C22.735 193.495 22.735 193.495 -1 194 C-1.33 192.68 -1.66 191.36 -2 190 C-4.24877707 186.45560772 -6.84182057 183.15789774 -9.375 179.8125 C-10.06078125 178.88501953 -10.7465625 177.95753906 -11.453125 177.00195312 C-12.11570313 176.12087891 -12.77828125 175.23980469 -13.4609375 174.33203125 C-14.06728027 173.52483643 -14.67362305 172.7176416 -15.29833984 171.88598633 C-16.95142472 169.74257072 -16.95142472 169.74257072 -20 169 C-20.33 168.01 -20.66 167.02 -21 166 C-21.66 165.67 -22.32 165.34 -23 165 C-23.33 164.01 -23.66 163.02 -24 162 C-24.66 161.67 -25.32 161.34 -26 161 C-26.33 160.01 -26.66 159.02 -27 158 C-28.33285249 155.08139857 -29.92553794 152.58952031 -31.8359375 150.015625 C-32.40014404 149.25233887 -32.96435059 148.48905273 -33.5456543 147.70263672 C-34.14933838 146.8932666 -34.75302246 146.08389648 -35.375 145.25 C-35.99479736 144.4161377 -36.61459473 143.58227539 -37.25317383 142.72314453 C-38.53530494 140.99914163 -39.81860005 139.27600381 -41.10302734 137.55371094 C-42.9106697 135.12025675 -44.7018809 132.67563499 -46.48828125 130.2265625 C-47.55449553 128.77590055 -48.62089248 127.32537284 -49.6875 125.875 C-50.17976074 125.19469727 -50.67202148 124.51439453 -51.17919922 123.81347656 C-53.90216157 120.0288181 -53.90216157 120.0288181 -58 118 C-59.79403055 117.88408552 -61.59186356 117.82347129 -63.3894043 117.79467773 C-64.50569214 117.77449585 -65.62197998 117.75431396 -66.77209473 117.73352051 C-67.94429565 117.71704468 -69.11649658 117.70056885 -70.32421875 117.68359375 C-71.40239868 117.66494263 -72.48057861 117.6462915 -73.59143066 117.6270752 C-77.62336951 117.55871806 -81.65544476 117.49860732 -85.6875 117.4375 C-94.700625 117.293125 -103.71375 117.14875 -113 117 C-113 142.08 -113 167.16 -113 193 C-125.87 193 -138.74 193 -152 193 C-152 129.31 -152 65.62 -152 0 C-128.219375 -0.185625 -104.43875 -0.37125 -79.9375 -0.5625 C-72.4312085 -0.62381104 -64.92491699 -0.68512207 -57.19116211 -0.74829102 C-48.01867676 -0.81628418 -48.01867676 -0.81628418 -43.72340393 -0.8467865 C-40.72618557 -0.86843282 -37.72900706 -0.89302841 -34.73182678 -0.91941833 C-30.90512831 -0.95301503 -27.07842312 -0.98154354 -23.25165856 -1.00645053 C-21.84950105 -1.01643087 -20.44735465 -1.02817032 -19.04522884 -1.0418998 C-5.05951793 -1.17695554 -5.05951793 -1.17695554 0 0 Z M-115 37 C-115 50.53 -115 64.06 -115 78 C-114.67 78 -114.34 78 -114 78 C-114 64.47 -114 50.94 -114 37 C-114.33 37 -114.66 37 -115 37 Z M-113 37 C-113 37.33 -113 37.66 -113 38 C-79.34 38 -45.68 38 -11 38 C-11 37.67 -11 37.34 -11 37 C-44.66 37 -78.32 37 -113 37 Z M-113 39 C-113 51.21 -113 63.42 -113 76 C-99.37894273 76.19830759 -85.75787765 76.38379384 -72.13634872 76.54658794 C-65.81162315 76.62269148 -59.48707553 76.70445642 -53.16259766 76.79907227 C-47.06138567 76.89014115 -40.9601526 76.96645291 -34.85861969 77.03244972 C-32.52850691 77.06026331 -30.19845182 77.09343249 -27.86849213 77.13199425 C-24.60990871 77.18501849 -21.35164171 77.21915337 -18.09277344 77.2487793 C-17.125327 77.26891586 -16.15788055 77.28905243 -15.16111755 77.30979919 C-14.27213272 77.31408936 -13.38314789 77.31837952 -12.46722412 77.32279968 C-11.31129572 77.33800927 -11.31129572 77.33800927 -10.13201523 77.35352612 C-7.41256338 76.90259254 -6.0840363 75.76510962 -4 74 C-3.154375 73.401875 -2.30875 72.80375 -1.4375 72.1875 C2.33097117 68.80553869 3.75386169 66.07459433 4.35546875 61.00390625 C4.63278321 54.52074383 4.22013394 49.87284737 0.484375 44.48828125 C-1.19472957 42.80475799 -2.87512476 42.03170595 -5 41 C-5.495 40.01 -5.495 40.01 -6 39 C-41.31 39 -76.62 39 -113 39 Z M42 53 C42 55.97 42 58.94 42 62 C42.33 62 42.66 62 43 62 C43 59.03 43 56.06 43 53 C42.67 53 42.34 53 42 53 Z M-113 77 C-113 77.33 -113 77.66 -113 78 C-79.67 78 -46.34 78 -12 78 C-12 77.67 -12 77.34 -12 77 C-45.33 77 -78.66 77 -113 77 Z M-7 114 C-3 115 -3 115 -3 115 Z M-113 115 C-113 115.33 -113 115.66 -113 116 C-95.18 116 -77.36 116 -59 116 C-59 115.67 -59 115.34 -59 115 C-76.82 115 -94.64 115 -113 115 Z ",
    fill: "#002449",
    transform: "translate(176,51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 4 3 C4.73734375 3.28875 5.4746875 3.5775 6.234375 3.875 C9.54467367 5.22156217 12.28256559 7.01196513 15.25 9 C16.30703125 9.70125 17.3640625 10.4025 18.453125 11.125 C21 13 21 13 22 15 C22.78375 15.309375 23.5675 15.61875 24.375 15.9375 C27.01061242 17.0042955 28.08095091 17.99372141 30 20 C30.99 20.33 31.98 20.66 33 21 C34.02104551 21.97850195 35.0206121 22.97980427 36 24 C38.78195508 25.96125013 38.78195508 25.96125013 41.125 27 C43 28 43 28 44 30 C45.6476038 30.71247732 47.31763529 31.37400383 49 32 C50.34050052 32.65213539 51.67661368 33.31379969 53 34 C53 34.66 53 35.32 53 36 C54.2065625 36.433125 54.2065625 36.433125 55.4375 36.875 C58 38 58 38 59 40 C61.11785113 41.11785113 61.11785113 41.11785113 64 42 C65.02104551 42.97850195 66.0206121 43.97980427 67 45 C69.31856917 46.54571278 71.50638429 47.79618552 74 49 C74 49.66 74 50.32 74 51 C79.80873845 54.41319405 79.80873845 54.41319405 86 57 C87.02104551 57.97850195 88.0206121 58.97980427 89 60 C91.8684413 62.10232344 91.8684413 62.10232344 95 63 C96.02104551 63.97850195 97.0206121 64.97980427 98 66 C99.485 66.99 99.485 66.99 101 68 C103 69.33333333 105 70.66666667 107 72 C107.99 72.4640625 107.99 72.4640625 109 72.9375 C111.09256827 74.04917689 112.33761776 75.33761776 114 77 C115.485 77.495 115.485 77.495 117 78 C122.79710145 81.5942029 122.79710145 81.5942029 124 84 C124.825 84.33 125.65 84.66 126.5 85 C129 86 129 86 130 88 C132.11785113 89.11785113 132.11785113 89.11785113 135 90 C136.91835958 91.10770691 138.81218718 92.25838174 140.6875 93.4375 C141.68136719 94.05496094 142.67523437 94.67242187 143.69921875 95.30859375 C144.45847656 95.86675781 145.21773437 96.42492187 146 97 C146 97.66 146 98.32 146 99 C146.763125 99.268125 147.52625 99.53625 148.3125 99.8125 C150.92313504 100.96603641 152.07385089 101.98629865 154 104 C154.99 104.33 155.98 104.66 157 105 C158.02104551 105.97850195 159.0206121 106.97980427 160 108 C160.99 108.66 161.98 109.32 163 110 C166 112 166 112 167.5 113.5625 C169.05202438 115.25516721 169.05202438 115.25516721 172 116 C172 117.65 172 119.3 172 121 C171.01 121.33 170.02 121.66 169 122 C168.525625 122.495 168.05125 122.99 167.5625 123.5 C165.74806281 125.24185971 164.44440923 125.57855013 162 126 C162 126.66 162 127.32 162 128 C161.01 128.33 160.02 128.66 159 129 C158.67 129.66 158.34 130.32 158 131 C157.01 131.33 156.02 131.66 155 132 C151.95865509 133.66924071 151.95865509 133.66924071 151 136 C150.01 136.33 149.02 136.66 148 137 C147.505 137.495 147.01 137.99 146.5 138.5 C145 140 145 140 142 141 C141.67 141.66 141.34 142.32 141 143 C140.01 143.33 139.02 143.66 138 144 C137.67 144.66 137.34 145.32 137 146 C136.01 146.33 135.02 146.66 134 147 C130.95865509 148.66924071 130.95865509 148.66924071 130 151 C127.4375 151.625 127.4375 151.625 125 152 C124.67 152.99 124.34 153.98 124 155 C123.01 155.33 122.02 155.66 121 156 C120.67 156.66 120.34 157.32 120 158 C119.01 158.33 118.02 158.66 117 159 C116.34 159.66 115.68 160.32 115 161 C113 163 113 163 110 164 C109.67 164.66 109.34 165.32 109 166 C108.01 166 107.02 166 106 166 C103.94729537 167.84188612 103.94729537 167.84188612 103 170 C102.01 170.33 101.02 170.66 100 171 C99.67 171.66 99.34 172.32 99 173 C98.01 173.33 97.02 173.66 96 174 C92.95865509 175.66924071 92.95865509 175.66924071 92 178 C91.01 178.33 90.02 178.66 89 179 C88.2575 179.7425 88.2575 179.7425 87.5 180.5 C86 182 86 182 83 183 C82.67 183.66 82.34 184.32 82 185 C81.01 185.33 80.02 185.66 79 186 C78.34 186.66 77.68 187.32 77 188 C75 190 75 190 72 191 C71.67 191.66 71.34 192.32 71 193 C70.01 193 69.02 193 68 193 C67.67 193.99 67.34 194.98 67 196 C65.35 196.33 63.7 196.66 62 197 C61.67 197.99 61.34 198.98 61 200 C60.01 200.33 59.02 200.66 58 201 C54.95865509 202.66924071 54.95865509 202.66924071 54 205 C53.01 205.33 52.02 205.66 51 206 C50.2884375 206.7425 50.2884375 206.7425 49.5625 207.5 C47.74806281 209.24185971 46.44440923 209.57855013 44 210 C44 210.66 44 211.32 44 212 C43.01 212.33 42.02 212.66 41 213 C40.67 213.66 40.34 214.32 40 215 C39.01 215.33 38.02 215.66 37 216 C33.95865509 217.66924071 33.95865509 217.66924071 33 220 C32.01 220.33 31.02 220.66 30 221 C29.525625 221.495 29.05125 221.99 28.5625 222.5 C26.74806281 224.24185971 25.44440923 224.57855013 23 225 C23 225.66 23 226.32 23 227 C22.01 227.33 21.02 227.66 20 228 C19.67 228.66 19.34 229.32 19 230 C18.01 230.33 17.02 230.66 16 231 C12.95865509 232.66924071 12.95865509 232.66924071 12 235 C11.01 235.33 10.02 235.66 9 236 C8.525625 236.495 8.05125 236.99 7.5625 237.5 C5.74806281 239.24185971 4.44440923 239.57855013 2 240 C2 240.66 2 241.32 2 242 C1.01 241.67 0.02 241.34 -1 241 C-1.02278992 210.44244166 -1.04049794 179.88488526 -1.05106533 149.32732046 C-1.05231611 145.72350334 -1.05361042 142.11968624 -1.05493164 138.51586914 C-1.05519395 137.79838391 -1.05545626 137.08089867 -1.05572652 136.34167146 C-1.06008331 124.70906332 -1.06797091 113.07646009 -1.0771528 101.44385488 C-1.08648909 89.51656947 -1.09205556 77.58928665 -1.09408849 65.66199774 C-1.09534006 58.95891102 -1.0983618 52.25583457 -1.10573006 45.55275154 C-1.11248607 39.25164821 -1.11461782 32.95056072 -1.11310768 26.64945412 C-1.1133842 24.32940332 -1.11539179 22.00935203 -1.11920547 19.68930435 C-1.12413618 16.53671057 -1.1230006 13.38417765 -1.12025452 10.23158264 C-1.12316736 9.30066789 -1.1260802 8.36975314 -1.12908131 7.41062886 C-1.11412121 1.11412121 -1.11412121 1.11412121 0 0 Z ",
    fill: "#F83100",
    transform: "translate(1328,27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.25941406 -0.01224609 2.51882813 -0.02449219 3.81640625 -0.03710938 C11.35408992 -0.04885032 18.40214382 0.48281626 25.75 2.1875 C26.46704102 2.35354736 27.18408203 2.51959473 27.92285156 2.69067383 C30.03575485 3.26520058 31.80763505 4.18498906 33.75 5.1875 C35.90058132 5.90436044 38.07031006 6.56473145 40.25 7.1875 C49.35 9.7875 49.35 9.7875 52.75 13.1875 C53.348125 13.331875 53.94625 13.47625 54.5625 13.625 C57.3399315 14.33919667 59.38236765 15.58774841 61.75 17.1875 C62.08 17.8475 62.41 18.5075 62.75 19.1875 C64.09189957 19.85844978 65.44668689 20.50417586 66.8125 21.125 C68.75 22.1875 68.75 22.1875 69.75 24.1875 C70.74 24.5175 71.73 24.8475 72.75 25.1875 C73.03875 25.826875 73.3275 26.46625 73.625 27.125 C74.57773319 29.39880879 74.57773319 29.39880879 77 30.0625 C80.72264131 31.58539872 83.32816646 33.98393538 85.75 37.1875 C85.90082031 37.81398437 86.05164062 38.44046875 86.20703125 39.0859375 C86.93736512 41.91269737 88.3908467 43.65152948 90.1875 45.9375 C91.11369141 47.13632813 91.11369141 47.13632813 92.05859375 48.359375 C92.61675781 48.96265625 93.17492188 49.5659375 93.75 50.1875 C94.41 50.1875 95.07 50.1875 95.75 50.1875 C95.83765625 50.87070313 95.9253125 51.55390625 96.015625 52.2578125 C96.9265992 55.8920181 98.65128721 58.84432349 100.5 62.0625 C106.25531037 72.46870942 109.89335343 83.41026427 111.75 95.1875 C112.41 95.1875 113.07 95.1875 113.75 95.1875 C113.7748244 99.7773398 113.79291873 104.36714001 113.80493164 108.95703125 C113.80994272 110.51660849 113.81675337 112.07618108 113.82543945 113.63574219 C113.83764686 115.88477736 113.84326068 118.1337501 113.84765625 120.3828125 C113.85281754 121.0736795 113.85797882 121.76454651 113.86329651 122.47634888 C113.86375529 126.48665055 113.5235266 130.25295295 112.75 134.1875 C112.09 134.1875 111.43 134.1875 110.75 134.1875 C110.07635339 136.26858685 109.41133202 138.3524671 108.75 140.4375 C108.193125 142.17773438 108.193125 142.17773438 107.625 143.953125 C106.57590405 147.2725928 106.57590405 147.2725928 106.75 151.1875 C106.09 151.1875 105.43 151.1875 104.75 151.1875 C104.481875 151.826875 104.21375 152.46625 103.9375 153.125 C102.75 155.1875 102.75 155.1875 99.75 156.1875 C98.40210653 157.16778616 97.06787285 158.16721135 95.75 159.1875 C92.06221482 161.03139259 87.78357552 160.54576551 83.75 160.1875 C78.17391304 158.03532609 78.17391304 158.03532609 76.75 155.1875 C75.76 154.8575 74.77 154.5275 73.75 154.1875 C72.75 152.0625 72.75 152.0625 71.75 149.1875 C71.234375 148.15625 70.71875 147.125 70.1875 146.0625 C68.10975124 141.32985005 68.01751979 136.2888257 67.75 131.1875 C68.41 131.1875 69.07 131.1875 69.75 131.1875 C71.5011306 124.51131459 71.94274215 118.24025023 71.9375 111.375 C71.9384668 110.13882935 71.9384668 110.13882935 71.93945312 108.87768555 C71.90342118 104.85725745 71.74446627 101.10967498 70.75 97.1875 C70.09 97.1875 69.43 97.1875 68.75 97.1875 C68.63785156 95.97126953 68.63785156 95.97126953 68.5234375 94.73046875 C67.28174132 84.27343915 64.02963179 75.08719316 55.75 68.1875 C55.09 67.8575 54.43 67.5275 53.75 67.1875 C53.5334375 66.2284375 53.5334375 66.2284375 53.3125 65.25 C52.88834965 62.80539145 52.88834965 62.80539145 49.75 61.1875 C48.76 60.8575 47.77 60.5275 46.75 60.1875 C46.316875 59.1975 46.316875 59.1975 45.875 58.1875 C45.50375 57.5275 45.1325 56.8675 44.75 56.1875 C43.08600601 55.84107122 41.41884942 55.50972741 39.75 55.1875 C37.46875 54.1015625 37.46875 54.1015625 35.25 52.8125 C34.074375 52.14154297 34.074375 52.14154297 32.875 51.45703125 C31.3041489 50.51856322 29.76665615 49.5237429 28.25 48.5 C25.15287192 46.87400776 22.16653433 46.31982959 18.73828125 45.71484375 C16.75 45.1875 16.75 45.1875 14.75 43.1875 C4.39156487 40.80536729 -6.87564106 41.45243731 -17.125 44 C-17.79644043 44.1652417 -18.46788086 44.3304834 -19.15966797 44.50073242 C-22.71458999 45.47396217 -24.78485762 46.49007976 -27.25 49.1875 C-30.9375 49.875 -30.9375 49.875 -34.25 50.1875 C-34.25 50.8475 -34.25 51.5075 -34.25 52.1875 C-35.9 52.5175 -37.55 52.8475 -39.25 53.1875 C-39.58 54.1775 -39.91 55.1675 -40.25 56.1875 C-40.95125 56.455625 -41.6525 56.72375 -42.375 57 C-46.40035913 58.66264833 -49.12230308 61.20105391 -52.25 64.1875 C-52.81847656 64.71859375 -53.38695312 65.2496875 -53.97265625 65.796875 C-58.09741648 70.04378075 -60.83370108 74.76581226 -63.5 80 C-63.8292749 80.63921387 -64.1585498 81.27842773 -64.49780273 81.93701172 C-69.28308841 91.74238369 -70.78325766 101.21156111 -70.6875 112.0625 C-70.68427734 113.20058105 -70.68105469 114.33866211 -70.67773438 115.51123047 C-70.54227768 123.66782549 -69.65244811 130.68388676 -66.25 138.1875 C-65.59 138.1875 -64.93 138.1875 -64.25 138.1875 C-64.25 139.8375 -64.25 141.4875 -64.25 143.1875 C-63.59 143.1875 -62.93 143.1875 -62.25 143.1875 C-62.023125 144.239375 -61.79625 145.29125 -61.5625 146.375 C-60.44123539 150.37605932 -58.2942474 152.37157116 -55.25 155.1875 C-54.58333333 156.52083333 -53.91666667 157.85416667 -53.25 159.1875 C-51.27915953 160.89556174 -49.51093369 162.07238219 -47.125 163.125 C-45.25 164.1875 -45.25 164.1875 -44.375 166.1875 C-42.70269697 169.16048316 -40.43103127 169.23319062 -37.25 170.1875 C-35.90724831 171.17481742 -34.57267727 172.17344743 -33.25 173.1875 C-31.92405895 173.54912029 -30.59061543 173.88478039 -29.25 174.1875 C-27.765 175.1775 -27.765 175.1775 -26.25 176.1875 C-25.26 176.5175 -24.27 176.8475 -23.25 177.1875 C-22.59 177.5175 -21.93 177.8475 -21.25 178.1875 C-11.16694405 182.67082716 0.99159023 183.17141467 11.75 181.1875 C13.77046444 180.22952117 15.77345821 179.23310153 17.75 178.1875 C23.767888 176.9839224 29.71645773 176.8978023 35.75 178.1875 C36.41 178.8475 37.07 179.5075 37.75 180.1875 C38.678125 180.3421875 38.678125 180.3421875 39.625 180.5 C42.72676921 181.50351357 43.89364292 183.60185978 45.75 186.1875 C45.42 186.8475 45.09 187.5075 44.75 188.1875 C45.20375 188.765 45.6575 189.3425 46.125 189.9375 C47.62743182 192.01779021 48.84984287 193.78708099 49.75 196.1875 C49.375 198.4375 49.375 198.4375 48.75 200.1875 C48.42 200.1875 48.09 200.1875 47.75 200.1875 C47.59144531 200.76757812 47.43289063 201.34765625 47.26953125 201.9453125 C45.61197226 207.4949299 43.7433475 210.99448513 39.75 215.1875 C39.21375 215.785625 38.6775 216.38375 38.125 217 C36.75 218.1875 36.75 218.1875 33.75 219.1875 C33.42 219.5175 33.09 219.8475 32.75 220.1875 C30.81687193 220.1230624 28.88326793 220.05492578 26.953125 219.9296875 C24.62505337 220.02176165 24.62505337 220.02176165 22.66235352 221.68530273 C18.67540149 223.74177987 15.36679724 223.56539722 10.94921875 223.48046875 C10.11284378 223.47622391 9.27646881 223.47197906 8.41474915 223.46760559 C5.75533235 223.45087364 3.096686 223.41323226 0.4375 223.375 C-1.37043173 223.35994604 -3.17837539 223.34625888 -4.98632812 223.33398438 C-9.40784689 223.30098816 -13.82879302 223.24924428 -18.25 223.1875 C-18.25 222.5275 -18.25 221.8675 -18.25 221.1875 C-21.22 221.1875 -24.19 221.1875 -27.25 221.1875 C-27.25 220.5275 -27.25 219.8675 -27.25 219.1875 C-28.03761719 219.11273438 -28.82523438 219.03796875 -29.63671875 218.9609375 C-38.28902088 217.9165176 -45.67891684 215.56825252 -53.25 211.1875 C-53.58 210.5275 -53.91 209.8675 -54.25 209.1875 C-54.91 209.0225 -55.57 208.8575 -56.25 208.6875 C-56.91 208.5225 -57.57 208.3575 -58.25 208.1875 C-58.58 207.5275 -58.91 206.8675 -59.25 206.1875 C-60.03375 205.878125 -60.8175 205.56875 -61.625 205.25 C-64.28143794 204.17477512 -65.31388902 203.20778972 -67.25 201.1875 C-67.95125 200.8575 -68.6525 200.5275 -69.375 200.1875 C-71.25 199.1875 -71.25 199.1875 -72.25 196.1875 C-73.1471875 196.0328125 -73.1471875 196.0328125 -74.0625 195.875 C-77.4424643 194.8127255 -78.36275849 192.07733856 -80.25 189.1875 C-82.35039331 187.79881484 -82.35039331 187.79881484 -84.25 187.1875 C-84.25 186.1975 -84.25 185.2075 -84.25 184.1875 C-85.52285745 182.51456775 -85.52285745 182.51456775 -87.25 180.8125 C-95.29314904 171.89368554 -100.24967095 161.49489562 -104.8046875 150.5234375 C-106.15278705 147.14026556 -106.15278705 147.14026556 -108.25 144.1875 C-112.84545482 136.88883647 -111.46861412 126.18106887 -111.49023438 117.8815918 C-111.49987279 115.65439517 -111.53093614 113.42815033 -111.5625 111.20117188 C-111.6236455 102.65561481 -110.88911547 94.85858939 -108.89746094 86.53930664 C-108.12496126 83.13409317 -108.12496126 83.13409317 -108.28222656 79.38452148 C-108.25 76.1875 -108.25 76.1875 -106.25 74.1875 C-104.64168726 71.7750309 -103.27929832 69.43821172 -101.9375 66.87890625 C-101.28394531 65.63463867 -101.28394531 65.63463867 -100.6171875 64.36523438 C-100.16601562 63.50220703 -99.71484375 62.63917969 -99.25 61.75 C-98.57324219 60.46125977 -98.57324219 60.46125977 -97.8828125 59.14648438 C-96.66745974 56.82904398 -95.45296902 54.51139345 -94.25 52.1875 C-93.89292969 51.497771 -93.53585937 50.80804199 -93.16796875 50.09741211 C-92.13337041 48.04752658 -92.13337041 48.04752658 -91.25 45.1875 C-89.9257268 44.5030128 -88.59104445 43.83851613 -87.25 43.1875 C-85.49039571 41.49197048 -85.49039571 41.49197048 -83.875 39.5 C-83.27558594 38.79101562 -82.67617187 38.08203125 -82.05859375 37.3515625 C-81.16333984 36.28035156 -81.16333984 36.28035156 -80.25 35.1875 C-79.14674919 33.9158715 -78.04265075 32.64497764 -76.9375 31.375 C-75.18525014 29.35391181 -73.74632896 27.43199344 -72.25 25.1875 C-71.26 24.8575 -70.27 24.5275 -69.25 24.1875 C-68.92 23.5275 -68.59 22.8675 -68.25 22.1875 C-67.26 21.8575 -66.27 21.5275 -65.25 21.1875 C-64.755 20.6925 -64.26 20.1975 -63.75 19.6875 C-62.25 18.1875 -62.25 18.1875 -59.25 17.1875 C-58.486875 16.56875 -57.72375 15.95 -56.9375 15.3125 C-51.8387103 11.28089884 -47.5944829 10.0938547 -41.25 9.1875 C-38.02450263 7.78775586 -35.73367169 6.67117169 -33.25 4.1875 C-30.91708189 4.14348268 -28.58299825 4.14795766 -26.25 4.1875 C-24.57442621 3.90229595 -22.90182755 3.58794304 -21.25 3.1875 C-21.25 2.5275 -21.25 1.8675 -21.25 1.1875 C-14.12890886 0.05757061 -7.19535871 0.00363769 0 0 Z M-14.25 1.1875 C-14.25 1.5175 -14.25 1.8475 -14.25 2.1875 C-11.61 2.1875 -8.97 2.1875 -6.25 2.1875 C-6.25 1.8575 -6.25 1.5275 -6.25 1.1875 C-8.89 1.1875 -11.53 1.1875 -14.25 1.1875 Z M7.75 1.1875 C7.75 1.5175 7.75 1.8475 7.75 2.1875 C10.06 2.1875 12.37 2.1875 14.75 2.1875 C14.75 1.8575 14.75 1.5275 14.75 1.1875 C12.44 1.1875 10.13 1.1875 7.75 1.1875 Z M15.75 2.1875 C15.75 2.5175 15.75 2.8475 15.75 3.1875 C17.73 3.1875 19.71 3.1875 21.75 3.1875 C21.75 2.8575 21.75 2.5275 21.75 2.1875 C19.77 2.1875 17.79 2.1875 15.75 2.1875 Z M-107.25 77.1875 C-106.25 80.1875 -106.25 80.1875 -106.25 80.1875 Z M68.75 90.1875 C69.75 92.1875 69.75 92.1875 69.75 92.1875 Z M-72.25 105.1875 C-72.25 109.4775 -72.25 113.7675 -72.25 118.1875 C-71.92 118.1875 -71.59 118.1875 -71.25 118.1875 C-71.25 113.8975 -71.25 109.6075 -71.25 105.1875 C-71.58 105.1875 -71.91 105.1875 -72.25 105.1875 Z M111.75 121.1875 C111.75 123.4975 111.75 125.8075 111.75 128.1875 C112.08 128.1875 112.41 128.1875 112.75 128.1875 C112.75 125.8775 112.75 123.5675 112.75 121.1875 C112.42 121.1875 112.09 121.1875 111.75 121.1875 Z M-110.25 132.1875 C-109.25 136.1875 -109.25 136.1875 -109.25 136.1875 Z M-109.25 137.1875 C-108.25 140.1875 -108.25 140.1875 -108.25 140.1875 Z M102.75 151.1875 C103.75 153.1875 103.75 153.1875 103.75 153.1875 Z M84.75 158.1875 C84.75 158.5175 84.75 158.8475 84.75 159.1875 C87.39 159.1875 90.03 159.1875 92.75 159.1875 C92.75 158.8575 92.75 158.5275 92.75 158.1875 C90.11 158.1875 87.47 158.1875 84.75 158.1875 Z M42.75 185.1875 C43.75 187.1875 43.75 187.1875 43.75 187.1875 Z M11.75 221.1875 C11.75 221.5175 11.75 221.8475 11.75 222.1875 C14.06 222.1875 16.37 222.1875 18.75 222.1875 C18.75 221.8575 18.75 221.5275 18.75 221.1875 C16.44 221.1875 14.13 221.1875 11.75 221.1875 Z ",
    fill: "#002449",
    transform: "translate(1139.25,35.8125)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.21 0 24.42 0 37 0 C37.33 33.66 37.66 67.32 38 102 C38.66 102 39.32 102 40 102 C40.495 108.93 40.495 108.93 41 116 C41.66 116 42.32 116 43 116 C43.020625 116.928125 43.04125 117.85625 43.0625 118.8125 C43.94362147 124.98035031 47.99194218 131.46833143 52.7265625 135.453125 C54.13549831 136.32763688 55.5664106 137.16651779 57 138 C57.68177416 139.32567199 58.35191436 140.65753688 59 142 C61.02463255 142.65213292 61.02463255 142.65213292 63 143 C63.33 143.66 63.66 144.32 64 145 C64.66 145.33 65.32 145.66 66 146 C67.485 146.99 67.485 146.99 69 148 C69.70125 148.165 70.4025 148.33 71.125 148.5 C71.74375 148.665 72.3625 148.83 73 149 C73.33 149.66 73.66 150.32 74 151 C76.32156597 151.40729228 78.6568787 151.74438677 81 152 C81 152.66 81 153.32 81 154 C85.10757963 154.07489276 89.2148876 154.12894754 93.32299805 154.16479492 C94.71662328 154.17975938 96.11020244 154.20013851 97.50366211 154.22631836 C110.85160242 154.74720677 110.85160242 154.74720677 122.3125 148.875 C123.1478125 147.946875 123.1478125 147.946875 124 147 C126.0625 146.375 126.0625 146.375 128 146 C131.04134491 144.33075929 131.04134491 144.33075929 132 142 C132.60972656 141.85691406 133.21945312 141.71382812 133.84765625 141.56640625 C139.83213035 139.99154464 144.07504122 132.90620094 147.07421875 127.85546875 C148.19536045 125.6084548 148.64613243 123.477073 149 121 C150.33333333 119 151.66666667 117 153 115 C154.19656349 109.14418171 154.13545008 103.33100263 154.11352539 97.38305664 C154.11374443 95.81607529 154.11374443 95.81607529 154.1139679 94.21743774 C154.11327401 90.78165576 154.10550616 87.34592871 154.09765625 83.91015625 C154.09579021 81.52119476 154.09436718 79.13223288 154.09336853 76.74327087 C154.089558 70.46824072 154.07974023 64.19323387 154.06866455 57.91821289 C154.05841893 51.50993159 154.05386416 45.10164651 154.04882812 38.69335938 C154.03811663 26.12889633 154.02125117 13.56444941 154 1 C157.27891925 -0.63945963 160.90613534 -0.12030178 164.5078125 -0.09765625 C165.34843231 -0.0962413 166.18905212 -0.09482635 167.05514526 -0.09336853 C169.74513275 -0.08776237 172.43503759 -0.07520886 175.125 -0.0625 C176.94661338 -0.05748579 178.76822807 -0.05292275 180.58984375 -0.04882812 C185.05992777 -0.03779094 189.52994986 -0.0205222 194 0 C194.04658039 12.87514676 194.08199876 25.75027309 194.10362434 38.62548733 C194.11400962 44.60558003 194.12807151 50.58561458 194.15087891 56.56567383 C194.17279636 62.34935633 194.18460802 68.13298331 194.18975449 73.91670418 C194.19341662 76.11041194 194.20056653 78.30411706 194.21146011 80.49780083 C194.36309437 112.33298694 194.36309437 112.33298694 189.6875 126.375 C189.47383789 127.02291504 189.26017578 127.67083008 189.04003906 128.33837891 C186.12854648 136.9304698 182.68153741 144.93646701 177 152 C175.95147814 153.34886572 174.91017203 154.70336216 173.875 156.0625 C173.37742187 156.71347656 172.87984375 157.36445313 172.3671875 158.03515625 C170.95649845 159.96001361 170.95649845 159.96001361 169.96875 162.078125 C168.50013655 164.9916646 166.43083902 166.85854658 164 169 C163.29875 169.165 162.5975 169.33 161.875 169.5 C159.69664981 169.85234349 159.69664981 169.85234349 158.4375 172.5 C157.963125 173.325 157.48875 174.15 157 175 C156.01 175.33 155.02 175.66 154 176 C153.505 176.495 153.01 176.99 152.5 177.5 C151 179 151 179 148 180 C147.401875 180.61875 146.80375 181.2375 146.1875 181.875 C142.07176235 185.87314514 138.58268728 187 133 187 C132.54625 187.474375 132.0925 187.94875 131.625 188.4375 C129.13957953 190.82732738 126.33550506 190.57548117 123 191 C122.34 191.66 121.68 192.32 121 193 C112.11338007 194.58526813 102.74362647 194.1830211 93.75 194.1875 C92.4403125 194.19974609 91.130625 194.21199219 89.78125 194.22460938 C83.14454255 194.23468535 77.33707206 194.00078918 71 192 C70.32420898 191.83395264 69.64841797 191.66790527 68.95214844 191.49682617 C66.5339398 190.88138663 64.30675686 189.94636179 62 189 C61.01 188.67 60.02 188.34 59 188 C57.59513683 187.33114545 56.19961398 186.64242678 54.8125 185.9375 C54.09707031 185.57527344 53.38164063 185.21304688 52.64453125 184.83984375 C52.10183594 184.56269531 51.55914063 184.28554687 51 184 C51 183.34 51 182.68 51 182 C49.865625 181.71125 48.73125 181.4225 47.5625 181.125 C46.386875 180.75375 45.21125 180.3825 44 180 C43.67 179.34 43.34 178.68 43 178 C42.34 177.67 41.68 177.34 41 177 C40.01 176.01 40.01 176.01 39 175 C38.01 174.67 37.02 174.34 36 174 C35.690625 173.34 35.38125 172.68 35.0625 172 C34.711875 171.34 34.36125 170.68 34 170 C33.34 169.835 32.68 169.67 32 169.5 C31.34 169.335 30.68 169.17 30 169 C29.71125 168.401875 29.4225 167.80375 29.125 167.1875 C28.06444929 164.68204084 28.06444929 164.68204084 24.9375 163 C22 161 22 161 21.58984375 159.28125 C20.71101323 155.88232931 18.64194789 153.3147912 16.625 150.5 C16.22539062 149.93152344 15.82578125 149.36304688 15.4140625 148.77734375 C13.7518102 146.42066367 12.07630598 144.09529616 10.2734375 141.84375 C8.87598357 139.82044247 8.51282249 138.39173515 8 136 C7.20147176 133.76579031 6.3872634 131.53715854 5.5625 129.3125 C1.23609758 117.38403456 -0.16188605 106.07709943 -0.11352539 93.43139648 C-0.11367142 92.41571091 -0.11381744 91.40002533 -0.1139679 90.3535614 C-0.11327617 87.02604978 -0.10551868 83.69859548 -0.09765625 80.37109375 C-0.09578944 78.05225149 -0.09436678 75.73340884 -0.09336853 73.41456604 C-0.08956408 67.33355608 -0.07975161 61.25257029 -0.06866455 55.17156982 C-0.05840576 48.95748217 -0.05386136 42.74339057 -0.04882812 36.52929688 C-0.03812737 24.3528523 -0.02054747 12.17643195 0 0 Z M155 99 C155 101.97 155 104.94 155 108 C155.33 108 155.66 108 156 108 C156 105.03 156 102.06 156 99 C155.67 99 155.34 99 155 99 Z M39 109 C40 112 40 112 40 112 Z M150 121 C151 123 151 123 151 123 Z M89 155 C89 155.33 89 155.66 89 156 C94.61 156 100.22 156 106 156 C106 155.67 106 155.34 106 155 C100.39 155 94.78 155 89 155 Z M74 191 C78 192 78 192 78 192 Z M116 191 C120 192 120 192 120 192 Z M79 192 C83 193 83 193 83 193 Z M111 192 C115 193 115 193 115 193 Z ",
    fill: "#00244A",
    transform: "translate(493,51)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.87 0 25.74 0 39 0 C38.97381592 3.29444092 38.94763184 6.58888184 38.9206543 9.9831543 C38.83757289 20.90343715 38.78248358 31.82373444 38.74093914 42.7442503 C38.71491544 49.36132805 38.67964887 55.97808026 38.62280273 62.5949707 C38.5682262 68.98814377 38.53852518 75.38100492 38.52561378 81.77439308 C38.51641992 84.20589923 38.49846699 86.63738951 38.47134972 89.06876183 C37.94031621 107.20525982 37.94031621 107.20525982 44 124 C45.84188612 126.05270463 45.84188612 126.05270463 48 127 C48.625 129.5625 48.625 129.5625 49 132 C49.99 132.33 50.98 132.66 52 133 C52.144375 133.61875 52.28875 134.2375 52.4375 134.875 C53.1996458 137.75421745 54.51192557 138.46324815 57 140 C57.99 140.33 58.98 140.66 60 141 C60.33 141.99 60.66 142.98 61 144 C62.1446875 144.1546875 62.1446875 144.1546875 63.3125 144.3125 C66.27011154 145.0690983 66.99230999 145.81772825 69 148 C71.60824522 149.64222847 74.22029966 150.3418942 77.1875 151.0625 C81 152 81 152 82 153 C83.66617115 153.04063832 85.33388095 153.042721 87 153 C87.33 153.66 87.66 154.32 88 155 C100.9907106 155.4155796 114.63095392 155.34532193 126 148 C126.33 147.01 126.66 146.02 127 145 C129 144.33333333 131 143.66666667 133 143 C133.33 142.01 133.66 141.02 134 140 C134.89525391 139.80664062 134.89525391 139.80664062 135.80859375 139.609375 C138.99841783 138.72236509 140.071618 136.8431334 142.0625 134.25 C142.73410156 133.38890625 143.40570313 132.5278125 144.09765625 131.640625 C147.68886464 126.6557033 149.39267568 123.19470803 150 117 C150.66 117 151.32 117 152 117 C154.36457669 109.5480599 155.44413957 102.82332036 155.43237305 95.02075195 C155.4425647 93.98526718 155.45275635 92.94978241 155.46325684 91.88291931 C155.49316046 88.50131663 155.50261808 85.11999825 155.51171875 81.73828125 C155.52858221 79.37744726 155.54673467 77.01662216 155.56611633 74.6558075 C155.61344121 68.47293882 155.64336376 62.29010619 155.66955566 56.1071167 C155.69944976 49.78553145 155.74594959 43.46407019 155.79101562 37.14257812 C155.87684954 24.76176966 155.94274658 12.38097366 156 0 C168.87 0 181.74 0 195 0 C195.04524776 14.16950922 195.08191452 28.33897017 195.10362434 42.50853539 C195.1140458 49.08856269 195.12817515 55.66853785 195.15087891 62.24853516 C195.17266558 68.60276423 195.18458095 74.95694326 195.18975449 81.31120682 C195.19343978 83.73119519 195.20063618 86.15118094 195.21146011 88.57114792 C195.2260523 91.96985469 195.2279747 95.36835661 195.22705078 98.76708984 C195.23424133 99.75971832 195.24143188 100.7523468 195.24884033 101.77505493 C195.23041478 108.07011584 194.46682921 113.87818594 193 120 C192.34 120 191.68 120 191 120 C190.72027344 120.92039062 190.44054687 121.84078125 190.15234375 122.7890625 C187.25081866 132.04660245 183.55882934 140.43381262 179 149 C178.67 149.66 178.34 150.32 178 151 C176.89256875 152.10743125 175.78288449 153.21267162 174.6640625 154.30859375 C166.40278233 162.44732534 166.40278233 162.44732534 160 172 C159.01 172.2165625 159.01 172.2165625 158 172.4375 C157.34 172.623125 156.68 172.80875 156 173 C155.67 173.99 155.34 174.98 155 176 C154.01 176.33 153.02 176.66 152 177 C151.4225 177.598125 150.845 178.19625 150.25 178.8125 C146.71240511 182.25182836 142.69734178 184.43421941 138 186 C137.01 186.66 136.02 187.32 135 188 C132.9785076 188.25669745 130.9563989 188.51107649 128.9296875 188.72265625 C125.33754513 189.23893582 122.97943602 191.01370932 120 193 C111.94897536 194.52903506 103.47837841 194.18627771 95.31005859 194.18530273 C93.23905528 194.18751167 91.16856756 194.20580954 89.09765625 194.22460938 C87.75781428 194.22754069 86.41796984 194.22952724 85.078125 194.23046875 C83.88606445 194.23457764 82.69400391 194.23868652 81.46582031 194.24291992 C77.0022485 193.93006743 72.92980485 192.99414189 68.9375 190.9375 C66.91835821 189.84285954 66.91835821 189.84285954 64.125 189.5625 C60.62654926 188.93277887 58.06437489 187.78161331 55 186 C54.67 185.34 54.34 184.68 54 184 C53.236875 183.855625 52.47375 183.71125 51.6875 183.5625 C48.69085163 182.93529453 47.32512976 181.93760813 45 180 C44.01 179.34 43.02 178.68 42 178 C41.01 177.01 41.01 177.01 40 176 C39.34 175.67 38.68 175.34 38 175 C37.01 174.01 37.01 174.01 36 173 C35.34 172.67 34.68 172.34 34 172 C33.07616346 170.96175646 32.18445614 169.89468118 31.3125 168.8125 C27.82829308 164.6605581 23.90045589 160.45022794 19 158 C18.87109375 157.44441406 18.7421875 156.88882813 18.609375 156.31640625 C17.76149164 153.09336244 16.05623077 150.73172543 14.25 147.9375 C8.67264664 139.09723913 4.69934509 130.11705761 2 120 C1.34 120 0.68 120 0 120 C0 80.4 0 40.8 0 0 Z M192 110 C192 111.65 192 113.3 192 115 C192.33 115 192.66 115 193 115 C193 113.35 193 111.7 193 110 C192.67 110 192.34 110 192 110 Z M73 191 C77 192 77 192 77 192 Z M116 191 C120 192 120 192 120 192 Z M78 192 C78 192.33 78 192.66 78 193 C79.65 193 81.3 193 83 193 C83 192.67 83 192.34 83 192 C81.35 192 79.7 192 78 192 Z M110 192 C110 192.33 110 192.66 110 193 C111.65 193 113.3 193 115 193 C115 192.67 115 192.34 115 192 C113.35 192 111.7 192 110 192 Z ",
    fill: "#002449",
    transform: "translate(259,51)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C63.69 0 127.38 0 193 0 C193 37 193 37 192 39 C167.25 39 142.5 39 117 39 C117 89.82 117 140.64 117 193 C103.47 193 89.94 193 76 193 C76 142.18 76 91.36 76 39 C50.92 39 25.84 39 0 39 C0 26.13 0 13.26 0 0 Z ",
    fill: "#002348",
    transform: "translate(728,51)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.21623047 0.03577148 1.21623047 0.03577148 2.45703125 0.07226562 C4.71831567 0.20869022 6.70667897 0.40439806 8.875 1.0625 C10.76953125 3.453125 10.76953125 3.453125 11.875 6.0625 C13.1434375 7.4546875 13.1434375 7.4546875 14.4375 8.875 C18.89095956 14.10550731 19.12484657 20.89082588 19.13569641 27.49375916 C19.14143473 28.54804362 19.14143473 28.54804362 19.14728898 29.62362677 C19.1575237 31.95481065 19.1536452 34.28574382 19.1496582 36.61694336 C19.15400994 38.29808274 19.15919462 39.97922014 19.16514587 41.66035461 C19.17849671 46.20994935 19.17911897 50.75946081 19.17658257 55.3090713 C19.17551032 59.1136687 19.18040268 62.91824942 19.185188 66.72284323 C19.19626939 75.70122792 19.19672812 84.67957077 19.19067383 93.65795898 C19.1846329 102.90678838 19.19695121 112.1554657 19.2182439 121.40426916 C19.23588023 129.35865525 19.2418581 137.31299302 19.23860615 145.26739794 C19.23679658 150.01222502 19.23939702 154.75694356 19.25332069 159.50175285 C19.26592771 163.96452514 19.26392783 168.42706084 19.25090981 172.88982964 C19.24855082 174.52280254 19.25125429 176.15579225 19.25953293 177.78874588 C19.31408959 189.39109841 18.669105 198.89016911 10.875 208.0625 C10.49730469 208.60777344 10.11960937 209.15304688 9.73046875 209.71484375 C6.71852414 211.90246668 3.28402773 211.64006247 -0.3125 211.75 C-1.06208984 211.78416016 -1.81167969 211.81832031 -2.58398438 211.85351562 C-4.43046838 211.93584294 -6.27770994 212.00085281 -8.125 212.0625 C-8.125 211.4025 -8.125 210.7425 -8.125 210.0625 C-8.99125 209.876875 -8.99125 209.876875 -9.875 209.6875 C-12.17599641 209.04833433 -14.06609615 208.26944364 -16.125 207.0625 C-16.455 206.4025 -16.785 205.7425 -17.125 205.0625 C-17.785 204.7325 -18.445 204.4025 -19.125 204.0625 C-19.51671753 202.40858154 -19.84557545 200.73904729 -20.125 199.0625 C-20.455 198.0725 -20.785 197.0825 -21.125 196.0625 C-21.22609328 193.6839997 -21.26442989 191.30270849 -21.27217102 188.92207336 C-21.27584771 188.19011519 -21.2795244 187.45815702 -21.2833125 186.70401829 C-21.29435004 184.24448495 -21.29819331 181.78499386 -21.30200195 179.32543945 C-21.30826659 177.56459926 -21.31491339 175.80376039 -21.32191467 174.04292297 C-21.34295875 168.2538851 -21.35331789 162.46484696 -21.36328125 156.67578125 C-21.36732878 154.68272576 -21.3714457 152.68967042 -21.37563133 150.69661522 C-21.39468435 141.33244243 -21.40891473 131.96827753 -21.4172433 122.60408908 C-21.4270143 111.79659983 -21.4533298 100.98931547 -21.49374419 90.18189842 C-21.52391222 81.82764014 -21.53871287 73.47344057 -21.54202431 65.11912888 C-21.54437417 60.12996374 -21.5533262 55.14101746 -21.57848549 50.15191078 C-21.60178295 45.45608095 -21.60599269 40.76061381 -21.59572411 36.06474113 C-21.59522903 34.34426288 -21.60154117 32.62376667 -21.61528015 30.9033432 C-21.73591827 14.89701213 -21.73591827 14.89701213 -17.125 8.0625 C-16.4134375 6.94875 -16.4134375 6.94875 -15.6875 5.8125 C-10.64484617 0.16472771 -7.28107387 -0.53176382 0 0 Z ",
    fill: "#002449",
    transform: "translate(985.125,44.9375)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.30453125 -0.00257813 2.6090625 -0.00515625 3.953125 -0.0078125 C7.34407074 0.11080083 10.45141052 0.33533767 13.75 1.125 C14.245 2.115 14.245 2.115 14.75 3.125 C15.41 3.455 16.07 3.785 16.75 4.125 C17.67171904 5.13049333 18.55820671 6.16856998 19.42333984 7.22314453 C22.7610119 11.18965152 26.32464237 14.87830957 29.9765625 18.5546875 C30.64666351 19.23048859 31.31676453 19.90628967 32.00717163 20.60256958 C33.4125734 22.01735039 34.81938181 23.43073518 36.22753906 24.84277344 C38.38288903 27.00792491 40.52734673 29.18351115 42.671875 31.359375 C44.04361246 32.73763473 45.41598599 34.11526177 46.7890625 35.4921875 C47.42768219 36.14315399 48.06630188 36.79412048 48.72427368 37.46481323 C49.32524872 38.06278717 49.92622375 38.66076111 50.54541016 39.27685547 C51.06914215 39.80423309 51.59287415 40.33161072 52.13247681 40.87496948 C53.99042394 42.3108009 55.48066686 42.62071571 57.75 43.125 C59.8203125 44.83203125 59.8203125 44.83203125 61.875 46.9375 C62.55820313 47.62457031 63.24140625 48.31164062 63.9453125 49.01953125 C65.64923054 51.00743563 66.59401006 52.80346647 67.75 55.125 C69.72956942 56.81588222 71.72945196 58.48330472 73.75 60.125 C77.38719612 65.58079419 78.89909079 69.79409982 78.8125 76.375 C78.80347656 77.26703125 78.79445313 78.1590625 78.78515625 79.078125 C78.77355469 79.75359375 78.76195312 80.4290625 78.75 81.125 C78.09 81.125 77.43 81.125 76.75 81.125 C76.6675 81.90875 76.585 82.6925 76.5 83.5 C76.2525 84.36625 76.005 85.2325 75.75 86.125 C73.8125 87.1875 73.8125 87.1875 71.75 88.125 C71.46125 88.764375 71.1725 89.40375 70.875 90.0625 C69.08203386 93.34960459 67.28248223 93.90690268 63.75 95.125 C56.36416526 95.97524173 50.69752594 95.77958552 44.75 91.125 C44.440625 90.50496094 44.13125 89.88492188 43.8125 89.24609375 C42.52151719 86.6688744 40.90449651 84.97848423 38.875 82.9375 C38.19695312 82.24269531 37.51890625 81.54789062 36.8203125 80.83203125 C34.93676246 79.01156126 34.93676246 79.01156126 32.84375 78.71875 C29.5000585 77.77053898 27.47834183 75.2444963 25.125 72.8125 C24.39023438 72.08256836 24.39023438 72.08256836 23.640625 71.33789062 C21.72517662 69.39365818 19.99585842 67.62866375 18.79100037 65.16040039 C17.65408299 62.93745971 16.4065442 61.54653198 14.63305664 59.796875 C14.00222672 59.16942383 13.37139679 58.54197266 12.72145081 57.89550781 C12.0412236 57.22874023 11.3609964 56.56197266 10.66015625 55.875 C9.95982773 55.17987305 9.25949921 54.48474609 8.53794861 53.76855469 C6.30082934 51.54923321 4.05714391 49.33670868 1.8125 47.125 C-0.42770827 44.91244862 -2.666431 42.69844545 -4.90223694 40.48144531 C-6.29289472 39.10299951 -7.68621744 37.72723579 -9.08250427 36.35449219 C-9.71648636 35.72704102 -10.35046844 35.09958984 -11.00366211 34.453125 C-11.55944443 33.9055957 -12.11522675 33.35806641 -12.68785095 32.79394531 C-15.27549389 30.02939826 -17.04459609 27.74121173 -18.25 24.125 C-17.74280233 17.23307868 -16.65780816 11.60136771 -12.25 6.125 C-11.71375 5.196875 -11.1775 4.26875 -10.625 3.3125 C-7.97842768 -0.89795597 -4.64533794 -0.00910851 0 0 Z ",
    fill: "#00244A",
    transform: "translate(1174.25,164.875)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 33.33 0 66.66 0 101 C-0.33 101 -0.66 101 -1 101 C-1 68 -1 35 -1 1 C-12.88 1 -24.76 1 -37 1 C-37 34.66 -37 68.32 -37 103 C-37.33 103 -37.66 103 -38 103 C-38.33 104.65 -38.66 106.3 -39 108 C-39.33 108 -39.66 108 -40 108 C-40 72.69 -40 37.38 -40 1 C-28.07057792 -4.96471104 -13.33749935 0 0 0 Z ",
    fill: "#000506",
    transform: "translate(687,51)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.67 1.99 1.34 2.98 1 4 C0.91032895 5.34742325 0.87446562 6.6988526 0.87415886 8.04925632 C0.87155111 8.87607743 0.86894336 9.70289853 0.86625659 10.55477482 C0.86848732 11.46293585 0.87071804 12.37109689 0.87301636 13.30677795 C0.87145637 14.27164845 0.86989638 15.23651895 0.86828911 16.23062795 C0.86428635 19.47806743 0.86746598 22.72546053 0.87060547 25.97290039 C0.86925112 28.29519173 0.86747099 30.61748285 0.86529541 32.93977356 C0.86072537 39.25771586 0.86250882 45.57564189 0.8656745 51.89358449 C0.86794426 57.82537644 0.86621481 63.75716634 0.8647473 69.68895834 C0.86189431 82.15215681 0.86517683 94.61534794 0.87054767 107.07854521 C0.87501659 117.78031311 0.8742387 128.48207018 0.86962891 139.18383789 C0.86428177 151.60324594 0.86216788 164.02264755 0.86524117 176.4420566 C0.86680358 183.01937301 0.86699867 189.59668194 0.86370468 196.17399788 C0.86082542 202.35531423 0.86280269 208.53661 0.86859894 214.71792412 C0.86992618 216.99240459 0.86953302 219.26688678 0.86733627 221.54136658 C0.86462342 224.63433668 0.86800759 227.72723991 0.87301636 230.82020569 C0.87078564 231.73059744 0.86855491 232.6409892 0.86625659 233.57896858 C0.74484072 237.92603586 0.74484072 237.92603586 2 242 C1.01 241.67 0.02 241.34 -1 241 C-1.02278992 210.44244166 -1.04049794 179.88488526 -1.05106533 149.32732046 C-1.05231611 145.72350334 -1.05361042 142.11968624 -1.05493164 138.51586914 C-1.05519395 137.79838391 -1.05545626 137.08089867 -1.05572652 136.34167146 C-1.06008331 124.70906332 -1.06797091 113.07646009 -1.0771528 101.44385488 C-1.08648909 89.51656947 -1.09205556 77.58928665 -1.09408849 65.66199774 C-1.09534006 58.95891102 -1.0983618 52.25583457 -1.10573006 45.55275154 C-1.11248607 39.25164821 -1.11461782 32.95056072 -1.11310768 26.64945412 C-1.1133842 24.32940332 -1.11539179 22.00935203 -1.11920547 19.68930435 C-1.12413618 16.53671057 -1.1230006 13.38417765 -1.12025452 10.23158264 C-1.12316736 9.30066789 -1.1260802 8.36975314 -1.12908131 7.41062886 C-1.11412121 1.11412121 -1.11412121 1.11412121 0 0 Z ",
    fill: "#CD2800",
    transform: "translate(1328,27)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 78.54 1 157.08 1 238 C0.67 238 0.34 238 0 238 C0 159.46 0 80.92 0 0 Z ",
    fill: "#000000",
    transform: "translate(1325,29)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 63.69 1 127.38 1 193 C0.67 193 0.34 193 0 193 C0 129.31 0 65.62 0 0 Z ",
    fill: "#000000",
    transform: "translate(22,51)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C63.69 0 127.38 0 193 0 C193 0.33 193 0.66 193 1 C129.31 1 65.62 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(728,49)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.98530321 4.11090804 2.12815651 7.95834232 2.13371277 12.18006897 C2.1371111 13.24805093 2.1371111 13.24805093 2.14057809 14.33760828 C2.14689559 16.71735768 2.14609019 19.0970498 2.14526367 21.47680664 C2.14825648 23.18531874 2.15165929 24.89383016 2.15544128 26.6023407 C2.16427089 31.23853259 2.1666189 35.87470602 2.16725707 40.5109055 C2.16820693 44.38043743 2.17188592 48.24996506 2.17542917 52.11949533 C2.18356898 61.24576278 2.18601375 70.37202036 2.18530273 79.49829102 C2.18470133 88.91810105 2.19526667 98.33785392 2.2110464 107.75764948 C2.22410976 115.84352357 2.22948717 123.92937894 2.22884732 132.0152635 C2.22859208 136.84546795 2.23145817 141.67562155 2.24202538 146.50581551 C2.25168666 151.04563742 2.25179913 155.58535964 2.24450874 160.12518501 C2.2434606 161.79250738 2.24583935 163.45983589 2.2518692 165.12714767 C2.25955947 167.40052155 2.25496428 169.67354854 2.24723816 171.94691467 C2.24778293 173.21986924 2.24832769 174.49282381 2.24888897 175.80435276 C2 179 2 179 0 183 C0 122.61 0 62.22 0 0 Z ",
    fill: "#000000",
    transform: "translate(1004,59)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 59.4 1 118.8 1 180 C0.67 180 0.34 180 0 180 C0 120.6 0 61.2 0 0 Z ",
    fill: "#000000",
    transform: "translate(962,61)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C47.52 0 95.04 0 144 0 C144 0.33 144 0.66 144 1 C96.48 1 48.96 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(25,49)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 36.96 1.66 73.92 2 112 C1.67 112 1.34 112 1 112 C-0.0117746 106.15414596 -0.1357922 100.49158609 -0.11352539 94.56665039 C-0.11367142 93.5415033 -0.11381744 92.5163562 -0.1139679 91.46014404 C-0.11327413 88.08929286 -0.10550689 84.71849772 -0.09765625 81.34765625 C-0.09579017 79.00353526 -0.09436716 76.65941388 -0.09336853 74.31529236 C-0.08955836 68.15862951 -0.0797409 62.00199041 -0.06866455 55.84533691 C-0.05841815 49.55770184 -0.053864 43.2700629 -0.04882812 36.98242188 C-0.03811727 24.65493751 -0.02105889 12.32747073 0 0 Z ",
    fill: "#000000",
    transform: "translate(491,51)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 35.97 1 71.94 1 109 C0.67 109 0.34 109 0 109 C0 73.03 0 37.06 0 0 Z ",
    fill: "#000000",
    transform: "translate(257,51)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 34.98 1 69.96 1 106 C0.67 106 0.34 106 0 106 C0 71.02 0 36.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(413,51)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 33.66 1 67.32 1 102 C0.67 102 0.34 102 0 102 C0 68.34 0 34.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(688,51)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 33.66 1 67.32 1 102 C0.67 102 0.34 102 0 102 C0 68.34 0 34.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(531,51)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.25941406 -0.01224609 2.51882813 -0.02449219 3.81640625 -0.03710938 C11.35482952 -0.04885147 18.3947289 0.5084967 25.75 2.1875 C21.8273332 4.8026112 20.31205423 3.94937045 15.75 3.1875 C13.33285839 3.12091666 10.91404362 3.10207954 8.49609375 3.125 C7.83215103 3.12878662 7.16820831 3.13257324 6.48414612 3.13647461 C4.38519406 3.14857009 2.28638762 3.16719052 0.1875 3.1875 C-2.58463216 3.21425619 -5.35669252 3.2341666 -8.12890625 3.25 C-9.96304077 3.26740234 -9.96304077 3.26740234 -11.83422852 3.28515625 C-15.07118623 3.19261225 -18.07527489 2.8039397 -21.25 2.1875 C-21.25 1.8575 -21.25 1.5275 -21.25 1.1875 C-14.12890886 0.05757061 -7.19535871 0.00363769 0 0 Z M-14.25 1.1875 C-14.25 1.5175 -14.25 1.8475 -14.25 2.1875 C-11.61 2.1875 -8.97 2.1875 -6.25 2.1875 C-6.25 1.8575 -6.25 1.5275 -6.25 1.1875 C-8.89 1.1875 -11.53 1.1875 -14.25 1.1875 Z M7.75 1.1875 C7.75 1.5175 7.75 1.8475 7.75 2.1875 C10.06 2.1875 12.37 2.1875 14.75 2.1875 C14.75 1.8575 14.75 1.5275 14.75 1.1875 C12.44 1.1875 10.13 1.1875 7.75 1.1875 Z ",
    fill: "#000812",
    transform: "translate(1139.25,35.8125)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C14.85 0 29.7 0 45 0 C45 0.33 45 0.66 45 1 C30.15 1 15.3 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(177,245)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.21 0 24.42 0 37 0 C37 0.33 37 0.66 37 1 C24.79 1 12.58 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(806,245)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 12.21 1 24.42 1 37 C0.67 37 0.34 37 0 37 C0 24.79 0 12.58 0 0 Z ",
    fill: "#000000",
    transform: "translate(922,51)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 12.21 1 24.42 1 37 C0.67 37 0.34 37 0 37 C0 24.79 0 12.58 0 0 Z ",
    fill: "#000000",
    transform: "translate(726,51)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.21 0 24.42 0 37 0 C37 0.33 37 0.66 37 1 C24.79 1 12.58 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(415,49)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36 0.33 36 0.66 36 1 C24.12 1 12.24 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(25,245)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36 0.33 36 0.66 36 1 C24.12 1 12.24 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(650,49)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36 0.33 36 0.66 36 1 C24.12 1 12.24 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(494,49)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36 0.33 36 0.66 36 1 C24.12 1 12.24 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(259,49)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.89171006 1.37186163 3.77946506 2.74643663 4.6484375 4.1328125 C7.31468367 7.81623929 10.72245848 10.86565204 14 14 C10.2954183 14 9.36907694 12.75902467 6.82617188 10.23632812 C6.32666016 9.72521484 5.82714844 9.21410156 5.3125 8.6875 C4.80138672 8.18798828 4.29027344 7.68847656 3.76367188 7.17382812 C0 3.38000668 0 3.38000668 0 0 Z ",
    fill: "#000102",
    transform: "translate(1194,229)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 8.91 1 17.82 1 27 C0.67 27 0.34 27 0 27 C0 18.09 0 9.18 0 0 Z ",
    fill: "#000000",
    transform: "translate(1026,134)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.21524305 1.40844718 5.32183868 3.10344786 7.75 5.625 C8.67039062 6.57246094 8.67039062 6.57246094 9.609375 7.5390625 C10.29773437 8.26222656 10.29773437 8.26222656 11 9 C10.34 9.66 9.68 10.32 9 11 C9 10.34 9 9.68 9 9 C8.01 8.67 7.02 8.34 6 8 C6 7.34 6 6.68 6 6 C5.01 5.67 4.02 5.34 3 5 C1.3125 2.4375 1.3125 2.4375 0 0 Z ",
    fill: "#000000",
    transform: "translate(1229,207)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 0.33 21 0.66 21 1 C14.07 1 7.14 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(580,245)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.33 20 0.66 20 1 C13.4 1 6.8 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1130,259)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.33 20 0.66 20 1 C13.4 1 6.8 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(346,245)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.27 1 12.54 1 19 C0.67 19 0.34 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#000000",
    transform: "translate(1210,138)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61 0 11.22 0 17 0 C17 0.33 17 0.66 17 1 C11.39 1 5.78 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(347,205)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.02725341 1.7290774 1.04650987 3.45828176 1.0625 5.1875 C1.07410156 6.15042969 1.08570313 7.11335937 1.09765625 8.10546875 C1.00486622 10.85576513 0.62111685 13.32479591 0 16 C-0.33 16 -0.66 16 -1 16 C-0.67 10.72 -0.34 5.44 0 0 Z ",
    fill: "#000000",
    transform: "translate(687,153)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 0.33 16 0.66 16 1 C10.72 1 5.44 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1132,78)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C0.67 14 0.34 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#000000",
    transform: "translate(1253,141)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.33 11 0.66 11 1 C7.37 1 3.74 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1171,163)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.67 9 0.34 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#000000",
    transform: "translate(1155,180)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93065133 2.60582371 1.14917407 3.64198224 0.0625 6.25 C-0.4634375 7.11625 -0.4634375 7.11625 -1 8 C-0.67 5.36 -0.34 2.72 0 0 Z ",
    fill: "#000000",
    transform: "translate(1071,127)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.625 1.8125 0.625 1.8125 1 4 C0.34 4.99 -0.32 5.98 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#000000",
    transform: "translate(684,173)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1144,216)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1129,216)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(1253,236)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-0.99 3.495 -0.99 3.495 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#000000",
    transform: "translate(399,185)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.67 2.99 1.34 3.98 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(497,180)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(1027,162)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(258,160)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(1069,135)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(1027,128)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(1251,125)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-0.66 2.67 -1.32 2.34 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(1182,247)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.01 2.67 1.02 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(1208,244)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(365,204)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.34 3.67 0.68 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(1208,181)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(1206,172)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(493,164)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(1209,158)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(298,157)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(1069,155)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(1028,123)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(178,110)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(178,102)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.99 1.34 2.98 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#000000",
    transform: "translate(1241,98)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2.66 -0.32 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#000000",
    transform: "translate(1038,97)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1149,79)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(184,55)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(997,50)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(981,44)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(1117,257)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(1108,255)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1187,236)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(1119,214)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#000000",
    transform: "translate(432,207)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(600,204)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(576,204)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(185,191)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(495,173)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(450,171)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(260,171)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1250,170)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(685,169)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(494,169)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1071,165)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1208,163)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1070,161)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(646,159)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(412,157)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1209,133)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(217,120)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1029,119)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(1248,114)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#000000",
    transform: "translate(217,93)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(1117,81)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#000000",
    transform: "translate(1126,79)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#000000",
    transform: "translate(206,72)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(1164,256)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(386,240)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1373,236)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(1123,215)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(1169,213)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(1227,205)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(605,203)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(608,202)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(373,202)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(1085,193)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#000000",
    transform: "translate(1491,152)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(1121,80)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#000000",
    transform: "translate(1214,64)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(177,52)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(1098,43)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#000000",
    transform: "translate(1115,38)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(988,256)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(975,255)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1106,254)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(383,241)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(389,239)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(626,238)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(311,235)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(542,233)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(540,232)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1113,212)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1106,209)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(371,203)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(611,201)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(567,201)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(379,200)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(330,200)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(381,199)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(328,199)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(383,198)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1182,164)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1169,164)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(177,164)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(180,163)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(168,91)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1105,86)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1115,82)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1405,79)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1093,45)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(989,45)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1096,44)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1101,42)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1173,41)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(1111,39)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogorut);
export default __webpack_public_path__ + "static/media/logorut.0342091b41bbb4b3fd7eba49dd2c3730.svg";
export { ForwardRef as ReactComponent };